'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { toasterApi } from '../../toast/ToastProvider';
import { MAX_APPLICATION_DOCS_FILES } from './applicationDocumentation.constants';
import {
  getApplicationDocumentationFileRejectDescription,
  getApplicationDocumentationFileRejectErrorCodes,
} from './applicationDocumentationFiles.utils';

export type DocumentationFileRejectDetails = {
  files: Array<{
    errors?: string[];
  }>;
};

export const useDocumentationFileRejectToast = () => {
  const t = useTranslations(
    'designSystem.documentsReports.applicationDocumentation',
  );

  return useCallback(
    (details: DocumentationFileRejectDetails) => {
      toasterApi.error({
        title: t('errors.failedToUploadFiles'),
        description: getApplicationDocumentationFileRejectDescription({
          errorCodes: getApplicationDocumentationFileRejectErrorCodes(details),
          tooManyFilesMessage: t('errors.tooManyFiles', {
            count: MAX_APPLICATION_DOCS_FILES,
          }),
          fallbackMessage: t('errors.pleaseTryAgain'),
        }),
      });
    },
    [t],
  );
};
